import { Link } from 'react-router-dom';

const footerLinks = {
  content: {
    title: '内容分类',
    links: [
      { label: '电视剧', path: '/category/tv-series' },
      { label: '电影', path: '/category/movies' },
      { label: '综艺', path: '/category/variety' },
      { label: '动漫', path: '/category/anime' },
      { label: '纪录片', path: '/category/documentary' },
    ],
  },
  service: {
    title: '会员服务',
    links: [
      { label: '会员权益', path: '/about' },
      { label: 'VIP 专区', path: '/category/vip' },
      { label: '会员充值', path: '/about' },
      { label: '常见问题', path: '/about' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about' },
      { label: '用户协议', path: '/about' },
      { label: '隐私政策', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-base font-bold">红</span>
              <span className="text-xl font-heading font-semibold text-background-50">红桃视频</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/50">
              红桃视频官网是您访问红桃视频的唯一官方正版入口，提供高清视频播放、最新影视资源、会员专属内容及安全稳定的观看体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500/80 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500/80 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500/80 text-background-50/60 hover:text-background-50 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg" />
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 红桃视频 版权所有 | 红桃视频官网 hongtaovideo.com
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}